import { toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null) ? _ctx.getClass('alertBannerMobile') : '') + ' ' + 
_ctx.getClass('alertBanner'))
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.getClass('alertBannerMessage'))
    }, [
      _createTextVNode(_toDisplayString(_ctx.bannerText) + " ", 1 /* TEXT */),
      _createCommentVNode("Either the connection is poor or you've been disconnected. Please reconnect to resume or <a href=\"#\" @click=\"tryAgain\">try again</a> ")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}